// extracted by mini-css-extract-plugin
module.exports = {"background":"zS0k1","bold":"_1ePdA"};